import { authSelectors } from 'ducks/auth'
import { Icon, Tooltip } from 'opensolar-ui'
import { useTranslate } from 'react-admin'
import { useSelector } from 'react-redux'
import {
  utilityTariffCatalogueRowIsManaged,
  type UtilityTariffCatalogueRow,
} from './utilityTariffCatalogueHelpers'
import { CatalogueSourceIconAnchor } from './utilityTariffCatalogStyles'

type UtilityTariffCatalogueSourceIconProps = {
  record?: UtilityTariffCatalogueRow | null
  suppressTooltip?: boolean
}

/** Lock vs person for public vs org-owned catalogue row (OpenSolar Managed / My Custom Tariff). */
export const UtilityTariffCatalogueSourceIcon = ({
  record,
  suppressTooltip = false,
}: UtilityTariffCatalogueSourceIconProps) => {
  const orgId = useSelector(authSelectors.getOrgId)
  const translate = useTranslate()

  if (record == null) {
    return null
  }

  const managed = utilityTariffCatalogueRowIsManaged(record, orgId)
  const title = managed ? translate('OpenSolar Managed') : translate('My Custom Tariff')
  const icon = (
    <CatalogueSourceIconAnchor>
      <Icon icon={managed ? 'lock' : 'person'} size="small" />
    </CatalogueSourceIconAnchor>
  )

  if (suppressTooltip) {
    return icon
  }

  return <Tooltip title={title}>{icon}</Tooltip>
}
